import { render } from "./nuestra_cultura_AS.vue?vue&type=template&id=373bed19&scoped=true"
import script from "./nuestra_cultura_AS.vue?vue&type=script&lang=js"
export * from "./nuestra_cultura_AS.vue?vue&type=script&lang=js"

import "./styles/shared_AS.css?vue&type=style&index=0&id=373bed19&scoped=true&lang=css&external"
import "./styles/nuestra_cultura_AS.css?vue&type=style&index=1&id=373bed19&scoped=true&lang=css&external"
import "./nuestra_cultura_AS.vue?vue&type=style&index=2&id=373bed19&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373bed19"]])

export default __exports__